import u from "umbrellajs";
import { validateEmail } from "./lib/Utils";
import { hideOverlay, showChangePasswordPanel } from "./modal";

function signIn(isMobile = false, withMessage = false) {
  const $form = u("#formSignIn");
  const $email = u($form).find("#email");
  const $password = u($form).find("#password");
  const $containerInput = u($form).find(".form-input-rounded");
  const $containerError = u($form).find(".container-error");
  const $containerSuccess = u($form).find("#messageSuccess");
  const $inputs = u($form).find(".inputs");
  const $button = u($form).find(".footer");
  const $checkList = u($form).find("#checkList");
  const showMessage = withMessage;

  $containerInput.removeClass("error");
  $containerError.text("");

  if (!$email.nodes[0].value) {
    $email.parent().addClass("error");
    $containerError.text("* El campo correo electrónico es obligatorio");
    return false;
  }

  if (!validateEmail($email.nodes[0].value)) {
    $email.parent().addClass("error");
    $containerError.text("* El correo electrónico es inválido");
    return false;
  }

  if (!$password.nodes[0].value) {
    $password.parent().addClass("error");
    $containerError.text("* El campo contraseña es obligatorio");
    return false;
  }

  $form.addClass("loading");

  fetch(`${MAIN_WEB_ROOT}ajax/app/main/home/login`, {
    method: "POST",
    body: new URLSearchParams($form.serialize()),
  })
    .then((response) => response.json())
    .then((data) => {
      $form.removeClass("loading");
      $containerSuccess.removeClass("show");
      $checkList.removeClass("show");

      if (data.login === "CHANGEPASSWORD") {
        if (isMobile) {
          $form.removeClass("show");
          $password.nodes[0].value = "";
          u("#formChangePassword").addClass("show");
        } else {
          //close sign in modal
          u(".modal-custom").removeClass("active");
          hideOverlay();
          u("body").nodes[0].style.overflow = "auto";

          //open modal change password
          showChangePasswordPanel();
        }
      } else {
        if (data.error == "OK") {
          localStorage.setItem("TOKEN", data.token);

          u(".modal-custom").removeClass("active");

          hideOverlay();

          u("body").nodes[0].style.overflow = "auto";

          if (isMobile) {
            window.location = MAIN_WEB_ROOT;
          }

          if (!isMobile) {
            getSignedUserTemplate();
          }

          //CRM CENTRALIZADO
          if (showMessage) {
            $checkList.addClass("show");
            $containerSuccess
              .addClass("show")
              .text("¡Bienvenido!, ha ingresado correctamente.");
            $email.nodes[0].value = "";
            $password.nodes[0].value = "";

            $inputs.nodes[0].style.display = "none";

            $button.nodes[0].style.display = "none";
          }
        } else {
          console.log("error");
          $containerError.text("Usuario o Contraseña inválidos");
        }
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  return false;
}

function recoveryPasswordMobile() {
  const $email = u("#Username");
  const $message = u("#messageErrorsRegister");
  const $form = u("#formPasswordRecovery");

  $message.text("");

  if (!$email.nodes[0].value) {
    $email.parent().addClass("error");
    $message.text("* El campo correo electrónico es obligatorio");
    return false;
  }
  if (!validateEmail($email.nodes[0].value)) {
    $email.parent().addClass("error");
    $message.text("* El correo electrónico es inválido");
    return false;
  }

  u(".form-custom").addClass("loading");

  fetch(`${MAIN_WEB_ROOT}ajax/app/main/home/rememberAjax`, {
    method: "POST",
    body: new URLSearchParams($form.serialize()),
  })
    .then((response) => response.json())
    .then((data) => {
      u(".form-custom").removeClass("loading");
      if (data.status === "OK") {
        u("#messageConfirm").text(data.message);
        u("#messageConfirm").nodes[0].style.display = "block";
      } else {
        $message.text(data.message);
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function savePasswordChange() {
  const $form = u("#passwordToken");
  const $password1 = u($form).find("#password1");
  const $password2 = u($form).find("#password2");
  const $containerInput = u($form).find(".form-input-rounded");
  const $containerError = u($form).find(".container-error");

  $containerInput.removeClass("error");
  $containerError.text("");

  if (!$password1.nodes[0].value) {
    $password1.parent().addClass("error");
    $containerError.text("* El campo nueva contraseña es obligatorio");
    return false;
  }

  if ($password1.nodes[0].value.length < 8) {
    $password1.parent().addClass("error");
    $containerError.text(
      "* El campo nueva contraseña debe tener al menos 8 digitos."
    );
    return false;
  }

  if (yastaConfigPasswordUseSecure == "YES") {
    if (!$password1.nodes[0].value.match(/\d/)) {
      $password1.parent().addClass("error");
      $containerError.text("*  Debe ingresar por lo menos 1 carácter numérico");
      return false;
    }
  }

  if (!$password2.nodes[0].value) {
    $password2.parent().addClass("error");
    $containerError.text("* El campo repetir contraseña es obligatorio");
    return false;
  }

  if ($password2.nodes[0].value.length < 8) {
    $password2.parent().addClass("error");
    $containerError.text(
      "* El campo repetir contraseña debe tener al menos 8 digitos."
    );
    return false;
  }

  if ($password2.nodes[0].value !== $password1.nodes[0].value) {
    $password2.parent().addClass("error");
    $containerError.text(
      "* La contraseña no coincide, por favor verifique que sean iguales"
    );
    return false;
  }

  $form.addClass("loading");

  fetch(`${MAIN_WEB_ROOT}ajax/app/main/home/saveNewPassword`, {
    method: "POST",
    body: new URLSearchParams($form.serialize()),
  })
    .then((response) => response.json())
    .then((data) => {
      $form.removeClass("loading");
      if (data.status == "OK") {
        u(".modal-custom").removeClass("active");
        u("body").nodes[0].style.overflow = "auto";

        if (window.location.host.includes("fie")) {
          window.location = `${MAIN_WEB_ROOT}loginFie`;
        } else {
          window.location = MAIN_WEB_ROOT;
        }
      } else {
        console.log("error");
        $containerError.text(data.message);
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });

  return false;
}

function recoveryPassword() {
  const $form = u("#formPasswordRecovery");
  const $email = u($form).find("#Username");
  const $containerInput = u($form).find(".form-input-rounded");
  const $containerError = u($form).find(".container-error");

  $containerInput.removeClass("error");
  $containerError.text("");

  if (!$email.nodes[0].value) {
    $email.parent().addClass("error");
    $containerError.text("* El campo correo electrónico es obligatorio");
    return false;
  }
  if (!validateEmail($email.nodes[0].value)) {
    $email.parent().addClass("error");
    $containerError.text("* El correo electrónico es inválido");
    return false;
  }

  $form.addClass("loading");
  $form.nodes[0].submit();
}

function logOut() {
  const userId = oUser.YASTA_USER_DEVICE_TOKEN
    ? oUser.YASTA_USER_DEVICE_TOKEN
    : "";

  fetch(
    `${MAIN_WEB_ROOT}ajax/app/main/home/logoutOnesignal?deviceToken=${userId}`
  )
    .then((response) => response.json())
    .then((data) => {
      if (data.status == "OK") {
        localStorage.setItem("TOKEN", "PUBLIC_BACKEND_TOKEN");
        if (window.location.host.includes("fie")) {
          window.location = `${MAIN_WEB_ROOT}loginFie`;
        } else {
          window.location = MAIN_WEB_ROOT;
        }
      }
    });
}

function getSignedUserTemplate() {
  fetch(`${MAIN_WEB_ROOT}ajax/app/main/home/options`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: "html",
  })
    .then((response) => response.text())
    .then((response) => {
      u("body").find(".container-options").html(response);
    });
}

function getPublicUserTemplate() {
  fetch(`${MAIN_WEB_ROOT}ajax/app/main/home/optionsHome`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: "html",
  })
    .then((response) => response.text())
    .then((response) => {
      u("#headerPhp .container-options").html(response);
    });
}

export {
  signIn,
  recoveryPassword,
  recoveryPasswordMobile,
  logOut,
  getSignedUserTemplate,
  getPublicUserTemplate,
  savePasswordChange,
};
